/* Corporate Grind - Mobile Polish JS v2.0 (Consolidated Sticky ATC) */
(function() {
  'use strict';
  
  // Only run on product pages
  if (!window.location.pathname.includes('/products/') && 
      !document.body.classList.contains('template-product')) return;
  
  // Prevent duplicate initialization
  if (window.__cgStickyCartInitialized) return;
  window.__cgStickyCartInitialized = true;
  
  const config = {
    isMobile: window.innerWidth <= 768,
    scrollThreshold: 400
  };
  
  /**
   * Create sticky cart bar - SINGLE IMPLEMENTATION
   * Classes: .cg-sticky-cart (primary), also handles .cg-sticky-atc for compatibility
   */
  function createStickyCart() {
    // Don't create if any sticky cart variant already exists
    if (document.querySelector('.cg-sticky-cart, .cg-sticky-atc')) {
      console.log('✅ Sticky cart already exists, skipping creation');
      return document.querySelector('.cg-sticky-cart, .cg-sticky-atc');
    }
    
    const productTitle = document.querySelector('.product__title h1, h1.product__title, .product__title')?.textContent || 'Product';
    const priceEl = document.querySelector('.price-item--regular, .price__regular .price-item, .price');
    const price = priceEl ? priceEl.textContent.trim() : '';
    
    const stickyBar = document.createElement('div');
    stickyBar.className = 'cg-sticky-cart';
    stickyBar.setAttribute('data-cg-sticky', 'true'); // Flag for duplicate detection
    stickyBar.innerHTML = `
      <div class="cg-sticky-cart-info">
        <div class="cg-sticky-cart-title">${productTitle.substring(0, 30)}${productTitle.length > 30 ? '...' : ''}</div>
        <div class="cg-sticky-cart-price">${price}</div>
      </div>
      <button class="cg-sticky-cart-btn" type="button">Add to Cart</button>
    `;
    document.body.appendChild(stickyBar);
    document.body.classList.add('has-sticky-cart');
    
    // Handle button click - scroll to original ATC
    const stickyBtn = stickyBar.querySelector('.cg-sticky-cart-btn');
    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      scrollToAddCart();
    });
    
    // Show/hide based on original ATC visibility
    const addToCartBtn = document.querySelector('.product-form__submit, button[name="add"], form[action*="/cart/add"] button[type="submit"]');
    
    if (addToCartBtn) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          stickyBar.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      
      observer.observe(addToCartBtn);
      
      // Sync disabled state with original button
      const syncState = () => {
        stickyBtn.disabled = addToCartBtn.disabled;
        stickyBtn.textContent = addToCartBtn.disabled ? 'Sold Out' : 'Add to Cart';
      };
      
      const mutationObserver = new MutationObserver(syncState);
      mutationObserver.observe(addToCartBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
      syncState();
    } else {
      // Fallback: scroll-based visibility
      window.addEventListener('scroll', () => {
        stickyBar.classList.toggle('visible', window.scrollY > config.scrollThreshold);
      }, { passive: true });
    }
    
    console.log('✅ CG Sticky Cart created');
    return stickyBar;
  }
  
  /**
   * Scroll to add to cart button with visual feedback
   */
  function scrollToAddCart() {
    const addBtn = document.querySelector('.product-form__submit, button[name="add"], form[action*="/cart/add"]');
    if (addBtn) {
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Visual flash
      addBtn.style.transition = 'all 0.3s';
      addBtn.style.transform = 'scale(1.05)';
      addBtn.style.boxShadow = '0 0 20px rgba(102,126,234,0.6)';
      setTimeout(() => {
        addBtn.style.transform = '';
        addBtn.style.boxShadow = '';
      }, 500);
    }
  }
  window.scrollToAddCart = scrollToAddCart;
  
  /**
   * Add to cart feedback toast
   */
  function showAddFeedback(message) {
    let feedback = document.querySelector('.cg-add-feedback');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'cg-add-feedback';
      document.body.appendChild(feedback);
    }
    feedback.textContent = message || '✓ Added to Cart!';
    feedback.classList.add('show');
    setTimeout(() => feedback.classList.remove('show'), 2500);
  }
  
  /**
   * Intercept add to cart forms for feedback
   */
  function interceptAddToCart() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        setTimeout(() => showAddFeedback('✓ Added to Cart!'), 500);
      }
    });
  }
  
  /**
   * Initialize
   */
  function init() {
    if (config.isMobile) {
      createStickyCart();
    }
    interceptAddToCart();
    
    // Handle resize to mobile
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasMobile = config.isMobile;
        config.isMobile = window.innerWidth <= 768;
        
        if (config.isMobile && !wasMobile && !document.querySelector('.cg-sticky-cart, .cg-sticky-atc')) {
          createStickyCart();
        }
      }, 250);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  console.log('✅ Corporate Grind Mobile v2.0 loaded');
})();
